// extracted by mini-css-extract-plugin
export default {"uri-value":"oAnaobL1CxUvVk4m4nH3","services":"_8tEQXY86HGpiVaCDcn8"};